import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-32 pb-20 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-6xl font-serif font-bold mb-4 text-pkstone-900">404</h1>
          <p className="text-xl text-pkstone-600 mb-8">Sorry, the page you're looking for doesn't exist.</p>
          <Link 
            to="/" 
            className="bg-pkgreen-600 hover:bg-pkgreen-700 text-white py-3 px-8 rounded-md inline-block font-medium transition-all duration-300"
          >
            Return to Home
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
